// Desc: Column visibility models for ReactTableGrid views
const ColumnVisibilityModels = {
  GENES_ALL: {
    symbol: true,
    description: true,
    ncbiID: false,

    gene_ensembl_id: false,
    proteinIDs: false,
    proteinClassIDs: true,
    numDiseasesAssociatedToGene: true,
    numVariantsAssociatedToGene: true,

    ncbi_type: false,
    numCTs: true,
    nct_id: false,
    pathwayName: false,
    pathwayID: false,

    numChemicals: false,
    DSI: true,
    DPI: true,

    PLI: true,
    numPublications: true,
    numberPmidsWithChemsIncludedInEvidence: false,
    firstRef: true,
    lastRef: true,
  },
  GENES_GDA_SUMMARY: {
    geneSymbol: false,
    diseaseName: true,
    diseaseUMLSCUI: false,
    geneNcbiID: false,
    geneEnsemblIDs: false,

    numGenesAssociatedToDisease: true,
    numVariantsAssociatedToDisease: true,
    geneDPI: true,
    geneDSI: true,
    score: true,
    sourceScore: true,
    numPMIDsupportingAssociation: true,

    numberChemsIncludedInEvidence: true,
    numberPmidsWithChemsIncludedInEvidence: true,
    numDBSNPsupportingAssociation: true,
    yearInitial: true,

    yearFinal: true,
    EI: true,
    EL: false,
    diseaseType: true,

    diseaseClassName_MSH: true,
    diseaseClassName_UMLS: false,
    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,

    disease_prevalence_class: false,
    disease_prevalence_type: false,
    disease_prevalence_geo_area: false,
    disease_inheritance: false,

    geneNcbiType: false,
    pathwayName: false,
    pathwayID: false,
    numCTs: true,
  },
  GENES_GDA_EVIDENCE: {
    geneSymbol: false,
    diseaseName: true,
    diseaseUMLSCUI: false,
    geneNcbiID: false,
    geneEnsemblIDs: false,

    numGenesAssociatedToDisease: false,
    numVariantsAssociatedToDisease: false,
    geneDPI: true,
    geneDSI: true,

    score: true,
    sourceScore: true,
    associationType: true,
    ancestry_name: true,
    source: false,

    sentenceHTML: true,
    chemsInSentence: true,
    chemIDs: false,
    pmid: true,

    pmYear: true,
    journal_abbrv: true,

    diseaseType: false,

    diseaseClassName_MSH: false,
    diseaseClassName_UMLS: false,
    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,

    geneNcbiType: false,
    pathwayName: false,

    pathwayID: false,
    chemical_effect: false,
    reference: true,
    reference_type: true,

    association: false,
    citation_count: false,
  },
  GENES_VDA_SUMMARY: {
    geneSymbol: false,
    variantStrID: true,
    diseaseName: true,
    diseaseUMLSCUI: false,
    geneNcbiIDs: false,
    numDiseasesAssociatedToVariant: true,

    score: true,
    sourceScore: true,
    mostSevereConsequences: true,
    numPMIDsupportingAssociation: true,
    numberChemsIncludedInEvidence: false,

    numberPmidsWithChemsIncludedInEvidence: false,
    yearInitial: true,
    yearFinal: true,
    EI: true,

    variantDSI: true,
    variantDPI: true,
    chromosome: true,
    coord: true,

    alleles: false,
    alleleFreqExome: false,
    alleleFreqGenome: false,
    DBSNPclass: false,

    polyphen_score: false,
    sift_score: false,

    diseaseType: false,

    diseaseClassName_MSH: false,
    diseaseClassName_UMLS: false,
    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,
    disease_prevalence_class: false,
    disease_prevalence_type: false,
    disease_prevalence_geo_area: false,
    disease_inheritance: false,
  },
  GENES_VDA_EVIDENCE: {
    geneSymbol: false,
    variantStrID: true,
    diseaseName: true,
    diseaseUMLSCUI: false,
    geneNcbiIDs: false,
    numDiseasesAssociatedToVariant: true,

    score: true,
    sourceScore: true,
    mostSevereConsequences: false,
    gof_lof: false,
    associationType: true,
    ancestry_name: true,

    sentenceHTML: true,
    chemsInSentence: true,
    chemIDs: false,
    chemical_effect: false,

    pmid: true,
    pmYear: true,
    journal_abbrv: true,
    source: false,

    variantDSI: false,
    variantDPI: false,
    pValue: false,
    // or_or_beta: false,

    chromosome: false,
    coord: false,
    alleleFreqExome: false,
    alleleFreqGenome: false,

    riskAllele: true,
    DBSNPclass: false,

    diseaseType: false,

    diseaseClassName_MSH: false,
    diseaseClassName_UMLS: false,
    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,

    // gender: true,
    beta: true,
    odds_ratio: true,
    clinical_significance: false,

    association: false,
    citation_count: false,
  },
  DISEASES_ALL: {
    name: true,
    diseaseUMLSCUI: false,
    type: true,
    diseaseClassName_MSH: true,

    diseaseClassName_UMLS: true,
    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,
    nct_id: false,

    numCTs: true,
    numGenesAssociatedToDisease: true,
    numVariantsAssociatedToDisease: true,
    numChemicals: false,
    numPublications: false,

    numPublications_GDA: true,
    numPublications_VDA: true,
    firstRef: true,
    lastRef: true,

    disease_prevalence_class: false,
    disease_prevalence_type: false,
    disease_prevalence_geo_area: false,
    disease_inheritance: false,
  },
  DISEASES_GDA_SUMMARY: {
    diseaseName: false,
    numGenesAssociatedToDisease: false,
    numVariantsAssociatedToDisease: false,
    geneSymbol: true,
    diseaseUMLSCUI: false,
    geneNcbiID: false,
    geneDescription: true,
    numDiseasesAssociatedToGene: true,

    numVariantsAssociatedToGene: true,
    score: true,
    sourceScore: true,
    numPMIDsupportingAssociation: true,
    numberChemsIncludedInEvidence: true,

    numberPmidsWithChemsIncludedInEvidence: true,
    numDBSNPsupportingAssociation: true,
    yearInitial: true,
    yearFinal: true,

    EI: true,
    EL: false,
    geneDSI: true,
    geneDPI: true,

    genepLI: true,
    geneEnsemblIDs: false,

    geneProteinStrIDs: false,
    geneProteinClassNames: false,
    geneNcbiType: false,
    pathwayName: false,

    pathwayID: false,
    numCTs: true,

    diseaseType: false,
    diseaseClassName_MSH: false,
    diseaseClassName_UMLS: false,
    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,
    disease_prevalence_class: false,
    disease_prevalence_type: false,
    disease_prevalence_geo_area: false,
    disease_inheritance: false,
  },
  DISEASES_GDA_EVIDENCE: {
    geneSymbol: true,
    diseaseName: false,
    diseaseUMLSCUI: false,
    geneNcbiID: false,

    geneDescription: false,
    numDiseasesAssociatedToGene: false,

    numVariantsAssociatedToGene: false,
    score: true,
    sourceScore: true,
    associationType: true,
    ancestry_name: true,

    source: false,
    sentenceHTML: true,
    chemsInSentence: true,
    chemIDs: false,

    pmid: true,
    pmYear: true,
    journal_abbrv: true,
    geneDSI: false,

    geneDPI: false,
    genepLI: false,

    geneEnsemblIDs: false,
    geneNcbiType: false,
    geneProteinStrIDs: false,
    geneProteinClassNames: false,

    pathwayName: false,
    pathwayID: false,
    chemical_effect: true,
    reference: true,

    reference_type: true,
    association: false,
    citation_count: false,
  },
  DISEASES_VDA_SUMMARY: {
    diseaseName: false,
    variantStrID: true,
    geneSymbol: true,
    diseaseUMLSCUI: false,
    geneNcbiIDs: false,

    numDiseasesAssociatedToVariant: true,

    score: true,
    sourceScore: true,
    mostSevereConsequences: true,
    numPMIDsupportingAssociation: true,
    numberChemsIncludedInEvidence: false,

    numberPmidsWithChemsIncludedInEvidence: false,
    yearInitial: true,
    yearFinal: true,
    EI: true,

    variantDSI: true,
    variantDPI: true,
    chromosome: true,
    coord: true,

    alleles: false,
    alleleFreqExome: false,
    alleleFreqGenome: false,
    DBSNPclass: false,

    polyphen_score: false,
    sift_score: false,

    diseaseType: false,
    diseaseClassName_MSH: false,
    diseaseClassName_UMLS: false,
    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,
  },
  DISEASES_VDA_EVIDENCE: {
    geneSymbol: true,
    diseaseName: false,
    diseaseUMLSCUI: false,
    geneNcbiIDs: false,
    variantStrID: true,

    numDiseasesAssociatedToVariant: false,
    score: true,
    sourceScore: true,
    mostSevereConsequences: false,

    gof_lof: true,
    chemical_effect: false,
    associationType: true,
    ancestry_name: true,

    sentenceHTML: true,
    chemsInSentence: true,
    chemIDs: false,
    pmid: true,

    pmYear: true,
    journal_abbrv: true,
    source: false,
    variantDSI: false,

    variantDPI: false,
    pValue: false,
    // or_or_beta: false,
    chromosome: false,

    coord: false,
    alleleFreqExome: false,
    alleleFreqGenome: false,
    riskAllele: true,

    DBSNPclass: false,
    // gender: true,
    beta: true,
    odds_ratio: true,

    clinical_significance: false,
    association: false,
    citation_count: false,
  },
  DISEASES_DDA_SUMMARY: {
    disease1_Name: false,
    ngenes_diseaseID_1: false,
    nvariants_diseaseID_1: false,
    disease1ClassName_DO: false,

    disease1ClassName_HPO: false,
    disease1ClassName_MSH: false,
    disease1ClassName_UMLS: false,
    disease1_Type: false,

    disease2_Name: true,
    ngenes_diseaseID_2: true,
    nvariants_diseaseID_2: true,
    disease2ClassName_DO: false,

    disease2ClassName_HPO: false,
    disease2ClassName_MSH: true,
    disease2ClassName_UMLS: false,
    disease2_Type: false,

    shared_genes: true,
    jaccard_genes: true,
    pvalue_jaccard_genes: true,
    shared_variants: true,

    jaccard_variants: true,
    pvalue_jaccard_variants: true,
    sokal: true,
    ddaRelation: true,

    disease1_UMLSCUI: false,
    disease2_UMLSCUI: false,
  },
  ngenes_diseaseID_SUMMARY: {
    geneSymbol: true,
    geneProteinStrIDs: true,
    geneDescription: true,
    geneProteinClassNames: true,

    geneDSI: true,
    geneDPI: true,
    genepLI: true,
  },
  nvariants_diseaseID_SUMMARY: {
    geneSymbol: true,
    variantStrID: true,
    variantDSI: true,
    variantDPI: true,

    mostSevereConsequences: true,
    chromosome: true,
    coord: true,
    alleles: true,

    alleleFreqExome: true,
    alleleFreqGenome: false,
    DBSNPclass: true,
    numDiseasesAssociatedToVariant: true,
  },
  VARIANTS_ALL: {
    strID: true,
    geneSymbol: true,
    polyphen_score: false,
    sift_score: false,

    numDiseasesAssociatedToVariant: true,
    numChemicals: false,
    DSI: true,
    DPI: true,
    chromosome: false,

    coord: false,
    DBSNPclass: false,
    mostSevereConsequences: true,
    alleles: true,

    exome: true,
    genome: false,
    numPublications: true,
    numberPmidsWithChemsIncludedInEvidence: false,
    
    firstRef: true,
    lastRef: true,
    gene_ncbi_id: false,
    gene_ensembl_id: false,
  },
  VARIANTS_VDA_SUMMARY: {
    variantStrID: true,
    geneSymbol: true,
    diseaseName: true,
    diseaseUMLSCUI: false,
    geneNcbiIDs: false,

    score: true,
    sourceScore: true,
    mostSevereConsequences: true,
    numPMIDsupportingAssociation: true,

    numberChemsIncludedInEvidence: false,
    numberPmidsWithChemsIncludedInEvidence: false,
    yearInitial: true,
    yearFinal: true,

    EI: true,
    variantDSI: true,
    variantDPI: true,
    chromosome: true,

    coord: true,
    alleles: false,
    exome: false,
    alleleFreqGenome: false,

    DBSNPclass: false,
    polyphen_score: false,
    sift_score: false,
    diseaseType: false,

    diseaseClassName_MSH: false,
    diseaseClassName_UMLS: false,
    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,

    disease_prevalence_class: false,
    disease_prevalence_type: false,
    disease_prevalence_geo_area: false,
    disease_inheritance: false,
  },
  VARIANTS_VDA_EVIDENCE: {
    variantStrID: true,
    geneSymbol: true,
    diseaseName: true,
    diseaseUMLSCUI: false,
    geneNcbiIDs: false,

    score: true,
    sourceScore: true,
    gof_lof: false,
    associationType: true,

    ancestry_name: true,
    sentenceHTML: true,
    chemsInSentence: true,

    chemIDs: false,
    chemical_effect: false,
    pmid: true,
    pmYear: true,

    journal_abbrv: true,
    source: false,
    pValue: false,
    // or_or_beta: false,

    riskAllele: true,
    diseaseType: false,
    diseaseClassName_MSH: false,

    diseaseClassName_UMLS: false,
    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,

    // gender: true,
    beta: true,
    odds_ratio: true,
    clinical_significance: false,

    association: false,
    citation_count: false,
  },
  CHEMICALS_ALL: {
    chemID: false,
    chemPrefName: true,
    chemMoleculeType: true,
    chemNumGDAs: true,
    chemNumPublicationsGDAs: true,

    chemNumVDAs: true,
    chemNumPublicationsVDAs: true,
    chemNumPublications: false,
    numCTs: false,

    chembl: false,
    chebi: false,
    pubchem: false,
    drugbank: false,
    mesh: false,
  },
  CHEMICALS_GDA_SUMMARY: {
    geneSymbol: true,
    geneDescription: true,
    diseaseName: true,
    diseaseUMLSCUI: false,
    geneNcbiID: false,
    numDiseasesAssociatedToGene: true,

    numDBSNPsupportingAssociation: false,
    numGenesAssociatedToDisease: true,
    numVariantsAssociatedToDisease: false,
    score: true,
    sourceScore: true,
    numPMIDsupportingAssociation: true,
    numberChemsIncludedInEvidence: true,
    numVariantsAssociatedToGene: true,
    yearInitial: true,

    yearFinal: true,
    EI: true,
    EL: true,
    geneDSI: true,

    geneDPI: true,
    genepLI: true,
    diseaseType: true,

    diseaseClassName_MSH: true,
    diseaseClassName_UMLS: false,
    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,
    disease_prevalence_class: false,
    disease_prevalence_type: false,
    disease_prevalence_geo_area: false,
    disease_inheritance: false,

    geneEnsemblIDs: false,
    geneNcbiType: false,
    geneProteinStrIDs: false,

    geneProteinClassNames: false,
    pathwayName: false,
    pathwayID: false,
    numCTs: true,
  },
  CHEMICALS_GDA_EVIDENCE: {
    geneSymbol: true,
    geneDescription: false,
    diseaseName: true,
    diseaseUMLSCUI: false,
    geneNcbiID: false,
    numDiseasesAssociatedToGene: false,

    numVariantsAssociatedToGene: false,
    numGenesAssociatedToDisease: false,
    numVariantsAssociatedToDisease: false,
    score: true,
    sourceScore: true,

    associationType: true,
    ancestry_name: true,
    source: false,
    geneNcbiType: false,
    sentenceHTML: true,

    chemsInSentence: true,
    chemIDs: false,
    pmid: true,
    pmYear: true,

    journal_abbrv: true,
    geneDSI: false,
    geneDPI: false,
    genepLI: false,

    diseaseType: false,
    diseaseClassName_MSH: false,
    diseaseClassName_UMLS: false,

    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,
    geneEnsemblIDs: false,

    geneProteinStrIDs: false,
    geneProteinClassNames: false,
    pathwayName: false,
    pathwayID: false,

    chemical_effect: false,
    reference: true,
    reference_type: true,
    association: false,

    citation_count: false,
  },
  CHEMICALS_VDA_SUMMARY: {
    geneSymbol: true,
    variantStrID: true,
    diseaseName: true,
    diseaseUMLSCUI: false,
    geneNcbiIDs: false,

    numDiseasesAssociatedToVariant: true,
    score: true,
    sourceScore: true,
    mostSevereConsequences: true,

    numberChemsIncludedInEvidence: false,
    numPMIDsupportingAssociation: true,
    yearInitial: true,
    yearFinal: true,

    EI: true,
    variantDSI: true,
    variantDPI: true,
    chromosome: false,

    coord: false,
    alleles: false,
    alleleFreqExome: false,
    alleleFreqGenome: false,

    DBSNPclass: false,
    polyphen_score: false,
    sift_score: false,
    diseaseType: false,

    diseaseClassName_MSH: false,
    diseaseClassName_UMLS: false,
    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,

    disease_prevalence_class: false,
    disease_prevalence_type: false,
    disease_prevalence_geo_area: false,
    disease_inheritance: false,
  },
  CHEMICALS_VDA_EVIDENCE: {
    geneSymbol: true,
    variantStrID: true,
    diseaseName: true,
    diseaseUMLSCUI: false,
    geneNcbiIDs: false,

    numDiseasesAssociatedToVariant: false,
    score: true,
    sourceScore: true,
    mostSevereConsequences: false,

    gof_lof: false,
    associationType: true,
    ancestry_name: true,
    sentenceHTML: true,

    chemsInSentence: true,
    chemIDs: false,
    pmid: true,

    pmYear: true,
    journal_abbrv: true,
    source: false,
    variantDSI: false,

    variantDPI: false,
    pValue: false,
    // or_or_beta: false,
    chromosome: false,

    coord: false,
    alleleFreqExome: false,
    alleleFreqGenome: false,
    riskAllele: true,

    DBSNPclass: false,
    diseaseType: false,
    diseaseClassName_MSH: false,
    diseaseClassName_UMLS: false,

    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,
    chemical_effect: false,
    clinical_significance: false,

    association: false,
    citation_count: false,
  },
  GDA_ALL_SUMMARY: {
    geneSymbol: true,
    geneDescription: true,
    geneNcbiID: false,
    diseaseName: true,

    diseaseUMLSCUI: false,
    numDiseasesAssociatedToGene: false,
    numVariantsAssociatedToGene: false,
    numGenesAssociatedToDisease: false,

    numVariantsAssociatedToDisease: false,
    score: true,
    sourceScore: true,
    numPMIDsupportingAssociation: true,
    numberChemsIncludedInEvidence: true,

    numberPmidsWithChemsIncludedInEvidence: true,
    numberNCTSWithChemsIncludedInEvidence: false,
    numDBSNPsupportingAssociation: true,
    yearInitial: true,
    yearFinal: true,

    EI: true,
    EL: true,
    geneDSI: true,
    geneDPI: true,

    genepLI: true,
    diseaseType: true,
    diseaseClassName_MSH: true,
    diseaseClassName_UMLS: false,

    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,
    disease_prevalence_class: false,
    disease_prevalence_type: false,

    disease_prevalence_geo_area: false,
    disease_inheritance: false,
    geneEnsemblIDs: false,
    geneNcbiType: false,

    geneProteinStrIDs: false,
    geneProteinClassNames: false,
    pathwayName: false,
    pathwayID: false,
    numCTs: true,
  },
  GDA_ALL_EVIDENCE: {
    geneSymbol: true,
    geneDescription: false,
    geneNcbiID: false,
    diseaseName: true,
    diseaseUMLSCUI: false,

    numDiseasesAssociatedToGene: false,
    numVariantsAssociatedToGene: false,
    numGenesAssociatedToDisease: false,
    numVariantsAssociatedToDisease: false,

    score: true,
    sourceScore: true,
    associationType: true,
    ancestry_name: true,
    source: false,

    geneNcbiType: false,
    sentenceHTML: true,
    chemsInSentence: true,
    chemIDs: false,
    // pmid: false,

    pmYear: true,
    journal_abbrv: true,
    geneDSI: false,
    geneDPI: false,

    genepLI: false,
    diseaseType: false,
    diseaseClassName_MSH: false,

    diseaseClassName_UMLS: false,
    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,

    geneEnsemblIDs: false,
    geneProteinStrIDs: false,
    geneProteinClassNames: false,
    pathwayName: false,

    pathwayID: false,
    chemical_effect: false,
    reference: true,
    reference_type: true,

    association: false,
    citation_count: false,
  },
  VDA_ALL_SUMMARY: {
    variantStrID: true,
    diseaseName: true,
    geneSymbol: true,
    diseaseUMLSCUI: false,
    geneNcbiIDs: false,

    numDiseasesAssociatedToVariant: true,
    score: true,
    sourceScore: true,
    mostSevereConsequences: true,

    numPMIDsupportingAssociation: true,
    numberChemsIncludedInEvidence: false,
    numberPmidsWithChemsIncludedInEvidence: false,
    yearInitial: true,

    yearFinal: true,
    EI: true,
    variantDSI: true,
    variantDPI: true,

    chromosome: false,
    coord: false,
    alleles: false,
    alleleFreqExome: false,

    alleleFreqGenome: false,
    DBSNPclass: false,
    polyphen_score: false,
    sift_score: false,

    diseaseType: false,
    diseaseClassName_MSH: false,
    diseaseClassName_UMLS: false,
    diseaseClassName_DO: false,

    diseaseClassName_HPO: false,
    disease_prevalence_class: false,
    disease_prevalence_type: false,
    disease_prevalence_geo_area: false,
    disease_inheritance: false,
  },
  VDA_ALL_EVIDENCE: {
    variantStrID: true,
    diseaseName: true,
    geneSymbol: true,
    diseaseUMLSCUI: false,
    geneNcbiIDs: false,

    numDiseasesAssociatedToVariant: false,
    score: true,
    sourceScore: true,
    mostSevereConsequences: false,

    gof_lof: false,
    associationType: true,
    ancestry_name: true,
    sentenceHTML: true,

    chemsInSentence: true,
    chemIDs: false,
    chemical_effect: false,

    // pmid: true,
    pmYear: true,
    journal_abbrv: true,
    source: false,

    variantDSI: false,
    variantDPI: false,
    pValue: false,
    // or_or_beta: false,

    chromosome: false,
    coord: false,
    alleleFreqExome: false,
    alleleFreqGenome: false,

    riskAllele: true,
    DBSNPclass: false,
    diseaseType: false,

    diseaseClassName_MSH: false,
    diseaseClassName_UMLS: false,
    diseaseClassName_DO: false,
    diseaseClassName_HPO: false,

    reference: true,
    reference_type: true,
    // gender: true,

    beta: true,
    odds_ratio: true,
    clinical_significance: false,
    association: false,

    citation_count: false,
  },
};

// Adding custom mapping columnLists
ColumnVisibilityModels['numberChemsIncludedInEvidenceGDA_SUMMARY'] = {
  chemID: false,
  chemPrefName: true,
  chemNumGDAs: true,
  chemNumPublicationsGDA: true,

  chemNumPublicationsGDAs: true,
  chemNumVDAs: true,
  chemNumPublicationsVDAs: true,
  chemNumPublications: false,
};
ColumnVisibilityModels['numberChemsIncludedInEvidenceVDA_SUMMARY'] = {
  chemID: false,
  chemPrefName: true,
  chemNumVDAs: true,
  chemNumPublicationsVDA: true,

  chemNumPublicationsVDAs: true,
  chemNumGDAs: true,
  chemNumPublicationsGDAs: true,
  chemNumPublications: false,
};
ColumnVisibilityModels['numberPmidsWithChemsIncludedInEvidenceGDA_EVIDENCE'] =
  ColumnVisibilityModels['GDA_ALL_EVIDENCE'];
ColumnVisibilityModels['numberPmidsWithChemsIncludedInEvidenceVDA_EVIDENCE'] =
  ColumnVisibilityModels['VDA_ALL_EVIDENCE'];
// ColumnVisibilityModels['numberPmidsWithChemsIncludedInEvidenceGDA_EVIDENCE'] =
//   ColumnVisibilityModels['GENES_ALL_EVIDENCE'];
// ColumnVisibilityModels['numberPmidsWithChemsIncludedInEvidenceVARIANTS_EVIDENCE'] =
//   ColumnVisibilityModels['VARIANTS_ALL_EVIDENCE'];
ColumnVisibilityModels['numPMIDsupportingAssociationGDA_EVIDENCE'] =
  ColumnVisibilityModels['GDA_ALL_EVIDENCE'];
ColumnVisibilityModels['numPMIDsupportingAssociationVDA_EVIDENCE'] =
  ColumnVisibilityModels['VDA_ALL_EVIDENCE'];
ColumnVisibilityModels['numChemicalsDISEASES_SUMMARY'] =
  {
    chemID: false,
    chemNumGDAs: true,
    chemNumVDAs: true,
    geneNcbiID: false,

    geneSymbol: true,
    geneDescription: true,
    diseaseUMLSCUI: false,
    diseaseName: true,

    chemNumPublications: false,
    chemNumPublicationsGDA: false,
    chemNumPublicationsGDAs: false,
    chemNumPublicationsVDAs: false,

    numPublications_ALL_NCTs: false,
    numPublicationsAllGDAs_ALL_NCTs: false,
    chemPrefName: false,
  };
// ColumnVisibilityModels['numChemicalsDISEASES_EVIDENCE'] =
//   ColumnVisibilityModels['DISEASES_GDA_EVIDENCE'];
// ColumnVisibilityModels['numChemicalsGENES_EVIDENCE'] =
//   ColumnVisibilityModels['GENES_GDA_EVIDENCE'];
ColumnVisibilityModels['numChemicalsVARIANTS_SUMMARY'] =
  {
    chemID: false, 
    chemNumGDAs: true,
    chemNumVDAs: true,
    variantStrID: false,

    geneNcbiIDs: true,
    geneSymbol: true,
    diseaseUMLSCUI: false,
    diseaseName: true,

    chemNumPublications: false,
    chemNumPublicationsVDA: false,
    chemNumPublicationsGDAs: false,
    chemNumPublicationsVDAs: false,

    numPublications_ALL_NCTs: false,
    numPublicationsAllGDAs_ALL_NCTs: false,
    chemPrefName: false,
  };
// ColumnVisibilityModels['numChemicalsVARIANTS_EVIDENCE'] =
//   ColumnVisibilityModels['VARIANTS_VDA_EVIDENCE'];


Object.defineProperty(ColumnVisibilityModels, 'getByViewTab', {
  // This method is used to get the column visibility model by view, tab, and isEvidence
  // the configuration dictionary keys are codified as: <TAB>_<VIEW>_<TYPE>
  value: function (VIEW, TAB, isEvidence) {
    // if view = 'ALL', entities _ALL view, not summary
    // if isEvidence is provided, override to evidence view
    let type;
    type = VIEW === 'ALL' ? 'ALL' : 'SUMMARY';
    type = isEvidence ? 'EVIDENCE' : type;

    // match the key that contains the view, tab, and type
    const allKeys = Object.keys(this);
    const keysWithView = allKeys.filter(key => key.includes(VIEW));
    const keysWithViewAndTab = keysWithView.filter(key => key.includes(TAB));
    const matchedKey = keysWithViewAndTab.filter(key => key.includes(type))[0];
    
    return matchedKey ? this[matchedKey] : undefined;
  },
  enumerable: false, // This keeps the custom method from being counted as one of the list items
});

Object.defineProperty(ColumnVisibilityModels, 'getByMappingName', {
  // This method is used to get the column visibility model by mapping name and isEvidence
  // the keys are synchronized with the "name" field of the Column.jsx component
  // codified as <MAPPING_NAME>_<TYPE>
  value: function (mappingName, isEvidence) {
    // Either a summary or evidence grid
    let type;
    type = isEvidence ? '_EVIDENCE' : '_SUMMARY';

    // match the key that contains the mapping name and type
    const matchedKey = Object.keys(this)
      .filter(key => key.includes(mappingName))
      .filter(key => key.includes(type))[0];
    return matchedKey ? this[matchedKey] : undefined;
  },
  enumerable: false, // This makes the property non-enumerable
});

export { ColumnVisibilityModels };
